import {AfterViewInit, Component, ElementRef, Inject, Input, OnInit, Renderer2, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import { BaseStepViewComponent } from '../base-step-view.class';
import { DatasetRecordService } from 'app/main/components/dataset/services/dataset-record.service';
import { DatasetActionContainerService } from 'app/main/components/dataset/services/dataset-action-container.service';
import { DatasetNavigatorService } from 'app/main/components/dataset/services/dataset-navigator.service';
import { DatasetService } from 'app/main/components/dataset/services/dataset.service';
import { AppService } from 'app/services/app.service';
import { Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { StepService } from 'app/main/components/dataset/services/step-state.service';

@Component({
    selector: 'integrations-step',
    templateUrl: './step.component.html',
    styleUrls: ['./step.component.scss'],
    providers: [DatasetActionContainerService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class IntegrationsStepComponent extends BaseStepViewComponent implements OnInit{
	
	@Input() parentDatasetACS: DatasetActionContainerService;
	@Input() hasStepState = false;
	@Input() datasetCode: string;
	@Input() integrationsDatasetCode: string;
	
	loading = false;
	fetchTourOperatorSubcription: Subscription;
	tourOperators: any[];

	private widget_entity_customer_id= ''
	public selectedWidgetColor: string = '#F39200';
	public widgetType = 1;
	constructor(
		public appService: AppService,
		public datasetRS: DatasetRecordService,
		public datasetACS: DatasetActionContainerService,
		protected datasetNavigatorService: DatasetNavigatorService,
		public datasetService: DatasetService,
		public stepService: StepService
	){
		// parent constructor
		super(datasetACS, datasetNavigatorService);
	}

	ngOnInit(): void{
		super.ngOnInit();
		this.loadTourOperators();
		// init datasetACS
		this.datasetACS.init({
			actionCode: 'list',
			datasetCode: this.integrationsDatasetCode,
			parentDatasetRS: this.datasetRS,
			parentDatasetACS: this.parentDatasetACS,
			fetchData: false,
			useBeforeCalls: false,
		}).subscribe(ready => {
			if (!ready) return;
			this.datasetACS.putContextData('contextual_domain_id', this.datasetACS.domainFilterService.filterDomainId.value);
		});
		// setta step come completato
		if (this.hasStepState){
			this.stepService.setStepState({
				dataset_code: this.datasetCode,
				form_code: 'integrations',
				record_id: this.datasetRS.recordId,
				status: 1
			});
		}
	}

	public loadTourOperators(newFilters?: Record<string, string|number>): void{
		if(this.fetchTourOperatorSubcription){
			this.fetchTourOperatorSubcription.unsubscribe();
		}

		if(newFilters){
			this.widget_entity_customer_id = newFilters.widget_entity_customer_id as string;
			this.selectedWidgetColor = newFilters.selectedWidgetColor as string;
			this.widgetType = newFilters.widgetType as number;
		}

		const params = {};
		if (this.datasetCode == 'trip_packages'){
			params['trip_package_id'] = this.datasetRS.recordId;
		}else{
			params['trip_category_id'] = this.datasetRS.recordId;
		}
		if(this.widget_entity_customer_id){
			params['widget_entity_customer_id'] = this.widget_entity_customer_id;
		}
		if(this.selectedWidgetColor){
			params['widget_color'] = this.selectedWidgetColor;
		}
		if(this.widgetType){
			params['widget_type'] = this.widgetType;
		}
		this.loading = true;
		this.fetchTourOperatorSubcription = this.datasetService.post<any[]>('/dataset/' + this.integrationsDatasetCode + '/command/get_for_tour_operators', params)
		.pipe(takeUntil(this._unsubscribeAll))
		.subscribe({
			next: response => {
				this.tourOperators = response;
				this.loading = false;
			},
			error: response => {
				this.loading = false;
			}
		});
	}

	createTripPackageIntegration(tourOperator): void{
		tourOperator.activating = true;

		// set request body
		const data = {
			tour_operator_id: tourOperator.id,
			tour_operator_code: tourOperator.code, // used when id not exist
			enabled: 1
		};
		if (this.datasetCode == 'trip_packages'){
			data['trip_package_id'] = this.datasetRS.recordId;
		}else{
			data['trip_category_id'] = this.datasetRS.recordId;
		}

		this.datasetService.post('/dataset/' + this.integrationsDatasetCode + '/create', data)
		.subscribe({
			next: response => {
				this.loadTourOperators();
			},
			error: response => {
				tourOperator.activating = false;
			}
		});
	}

	trackByIndex(index, item): any{
		return indexedDB;
	}

	integrationUpdated(integration: any, tourOperator: any): void{
		const newTOs = [];
		for (const t of this.tourOperators) {
			if(t.id === tourOperator.id){
				t.integration = integration;
			}
			newTOs.push(t);
		}
		this.tourOperators = newTOs;
	}
}